import React from 'react';
import { Card } from 'react-bootstrap';
import moment from 'moment';

/** Format Firestore Timestamp (seconds/nanoseconds or _seconds/_nanoseconds) or ISO string to readable datetime */
const formatTs = (ts) => {
  if (!ts) return 'N/A';
  let ms = null;
  if (typeof ts === 'object') {
    const seconds = ts.seconds ?? ts._seconds;
    const nanoseconds = ts.nanoseconds ?? ts._nanoseconds ?? 0;
    if (typeof seconds === 'number') {
      ms = seconds * 1000 + (nanoseconds / 1e6);
    }
  }
  if (ms == null) {
    const d = new Date(ts);
    ms = Number.isFinite(d.getTime()) ? d.getTime() : null;
  }
  return ms != null ? moment(ms).format('YYYY-MM-DD HH:mm') : 'N/A';
};

const TIMESTAMP_FIELDS = [
  { key: 'allocatedTime', label: 'Allocated' },
  { key: 'acknowledgedTime', label: 'Acknowledged' },
  { key: 'atLocationTime', label: 'At Location' },
  { key: 'startTime', label: 'Start' },
  { key: 'stopTime', label: 'Stop' },
  { key: 'completeTime', label: 'Complete' },
  { key: 'pickUpTime', label: 'Pick Up' },
  { key: 'boardingStartTime', label: 'Boarding Start' },
];

const TaskTimestampsCard = ({ tasks }) => {
  if (!Array.isArray(tasks) || tasks.length === 0) return null;

  return (
    <Card
      style={{
        marginBottom: 24,
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
      <Card.Header
        style={{
          fontSize: 16,
          fontWeight: 600,
          color: '#374151',
          backgroundColor: '#f9fafb',
          borderBottom: '1px solid #e5e7eb',
          padding: '12px 16px',
        }}
      >
        <i className="fas fa-clock" style={{ marginRight: 8, color: '#6b7280' }} />
        Task Timestamps
      </Card.Header>
      <Card.Body style={{ padding: 16 }}>
        {tasks.map((task, idx) => (
          <div
            key={task?._id || idx}
            style={{
              marginBottom: tasks.length > 1 ? 20 : 0,
              paddingBottom: tasks.length > 1 ? 16 : 0,
              borderBottom: tasks.length > 1 && idx < tasks.length - 1 ? '1px solid #e5e7eb' : 'none',
            }}
          >
            {tasks.length > 1 && (
              <div style={{ fontSize: 13, fontWeight: 600, color: '#6b7280', marginBottom: 8 }}>
                Task {idx + 1} {task?._id ? `(${String(task._id).slice(0, 30)}...)` : ''}
              </div>
            )}
            <table style={{ width: '100%', fontSize: 14 }}>
              <tbody>
                {TIMESTAMP_FIELDS.map(({ key, label }) => {
                  const val = task?.[key];
                  if (!val) return null;
                  return (
                    <tr key={key}>
                      <td style={{ padding: '4px 8px 4px 0', color: '#6b7280', width: 140 }}>{label}</td>
                      <td style={{ padding: 4, color: '#374151' }}>{formatTs(val)}</td>
                    </tr>
                  );
                })}
                {(task?.paxPositionInfo?.time || task?.checkInTime) && (
                  <tr>
                    <td style={{ padding: '4px 8px 4px 0', color: '#6b7280', width: 140 }}>Check-in</td>
                    <td style={{ padding: 4, color: '#374151' }}>
                      {formatTs(task.paxPositionInfo?.time || task.checkInTime)}
                    </td>
                  </tr>
                )}
                {task?.pickUpLocation && (
                  <tr>
                    <td style={{ padding: '4px 8px 4px 0', color: '#6b7280', width: 140 }}>Pick-up</td>
                    <td style={{ padding: 4, color: '#374151' }}>{task.pickUpLocation.name || task.pickUpLocation.id || 'N/A'}</td>
                  </tr>
                )}
                {task?.dropOffLocation && (
                  <tr>
                    <td style={{ padding: '4px 8px 4px 0', color: '#6b7280', width: 140 }}>Drop-off</td>
                    <td style={{ padding: 4, color: '#374151' }}>{task.dropOffLocation.name || task.dropOffLocation.id || 'N/A'}</td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Passenger details */}
            {Array.isArray(task?.passengers) && task.passengers.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#6b7280', marginBottom: 6 }}>Passengers</div>
                <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#374151' }}>
                  {task.passengers.map((p, i) => (
                    <li key={i}>
                      {p?.name || 'N/A'}
                      {Array.isArray(p?.assistance) && p.assistance.length > 0 && (
                        <span style={{ color: '#6b7280', marginLeft: 8 }}>
                          ({p.assistance.join(', ')})
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default TaskTimestampsCard;
